import { z } from "zod";

export const UserSchema = z.object({
  id: z.string().uuid(),
  firebaseUid: z.string().min(1),
  email: z.string().email(),
  displayName: z.string().optional().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type User = z.infer<typeof UserSchema>;
